// ======================================================================
// cg-selectors.js — Cub & Grey PDP selector behaviour  (T-505, Option A)
// ======================================================================
// 2026-06-22. JS VARIANT ENGINE (supersedes the rerender-proxy build).
//
// THE FLICKER FIX. Colour / Hardware / Size(or Length) are NATIVE Shopify
// variant axes. The OLD build clicked the hidden native radio on every tap,
// which fired Prestige's Section Rendering API (full product-section DOM
// swap ~280ms) PLUS ~1.1s of post-rerender cleanup passes — read by the user
// as the modal "closing and reopening for a few seconds".
//
// This build NEVER triggers a section rerender while the modal is open.
// On each tap it updates, purely in JS:
//   • the cart variant id   (writes <input name="id">.value — theme.js reads
//                            this on submit, theme.js:2797 / 3424)
//   • the modal price        (from the server-rendered .cg-variant-data map,
//                            so NO JS money-formatting risk)
//   • the modal preview image
//   • the in-drawer Add button availability
//   • the trigger pill label + dots
// → instant, no reflow, no flicker.
//
// PDP-behind (gallery / URL / sticky bar) is synced with ONE Prestige variant
// change ONLY when the modal CLOSES — invisible, because the modal is gone.
//
// Properties (line items): Personalisation (optional, 8 chars, free) and, for
// XL Hound only, a free-text Size. Survive the close-sync rerender via cgState.
//
// Guard: runs only when .cg-pdp is present.
// ======================================================================
(function () {
  'use strict';
  // CUTOVER GATE (T-505 Phase A): only run on products restructured to native
  // Size/Length variants. On un-restructured C&G products the engine stays off,
  // the native variant-picker stays visible, and Infinity Options keeps working —
  // so the live theme deploy is inert until each product's gated cutover.
  if (!document.querySelector('.cg-pdp--native')) return;

  // T-826: product id for the select_options_open telemetry below, read the same way CA's
  // `pid` is (cats-atelier-pdp.js) -- from a data-product-id attribute on the vendor wrapper div.
  // C&G's wrapper (.cg-pdp, set by product.cub-grey.json) does not carry that attribute today;
  // this diff adds it there in the same change (see product.cub-grey.json.diff). Falls back to
  // the literal 'cg' if the attribute is ever missing, so a stale/un-updated template never
  // throws -- it just tags the event with a placeholder id instead of crashing.
  var cgPid = (document.querySelector('.cg-pdp')?.dataset?.productId) || 'cg';

  // Canonical truth for line-item PROPERTIES (survives the close-sync rerender,
  // which wipes hidden inputs + the <dialog>). Variant axes live in the DOM
  // (vmirror active classes) — the variant-data map resolves them to a variant.
  var cgState = Object.create(null); // e.g. cgState['Personalisation'] = 'Max'

  // When true, the next dialog 'close' must NOT trigger a Prestige sync (used by
  // the in-drawer Add path, which submits immediately and must not race a fetch).
  var cgSkipCommit = false;

  // ── variant data (rendered by cg-selectors.liquid) ─────────────────
  var cgVariants = null;
  function getVariants() {
    // Re-read after a close-sync rerender (the <script> is inside the section).
    var el = document.querySelector('.cg-variant-data');
    if (!el) return cgVariants || [];
    try {
      var arr = JSON.parse(el.textContent);
      if (Array.isArray(arr)) { cgVariants = arr; return arr; }
    } catch (e) { /* fall through */ }
    return cgVariants || [];
  }

  // T-751/T-753 (2026-08-05): scope to <product-form>. Since T-667 enabled Shopify's native
  // `payment_terms` block (live 2026-07-25), the FIRST cart/add form in the document is Klarna's
  // installment form, which is never submitted. That broke TWO things at once here:
  //   1. injectProperty() wrote properties[Personalisation] / properties[Size] into it, so the
  //      engraving text and the XL Hound bespoke neck measurement never reached the order.
  //   2. applySelection() wrote the chosen variant id into ITS input[name=id]. The in-drawer
  //      "Add to Basket" sets cgSkipCommit=true, so the native radios are deliberately NOT
  //      touched — meaning that hidden id was the ONLY carrier of the customer's choice, and the
  //      real form submitted whatever variant the last server render left behind. Proven live:
  //      choosing Whisky Tan / Silver / L posted the id for Jet Black / Brass / XS.
  // <product-form> is how theme.js itself finds the real cart form (ProductForm, L2777).
  function getForm() {
    return document.querySelector('product-form form[action*="cart/add"]')
        || document.querySelector('form[action*="cart/add"]:not([id$="-payment-installment"])');
  }
  function getIdInput() { var f = getForm(); return f ? f.querySelector('input[name="id"]') : null; }

  // ── read the chosen value for each axis from the active vmirror buttons ─
  function getSelectedOptions() {
    var sel = Object.create(null);
    document.querySelectorAll('.cg-vmirror-group').forEach(function (g) {
      var axis = g.dataset.cgVmirrorAxis;
      if (!axis || sel[axis] != null) return; // dialog + inline render twice
      var active = g.querySelector('.cg-vmirror-btn--active');
      if (active) sel[axis] = active.dataset.cgVmirrorVal;
    });
    return sel;
  }

  // ── resolve the current selection to a single variant ──────────────
  function findVariant(sel) {
    var variants = getVariants();
    var axes = Object.keys(sel);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      if (!v || !v.opts) continue;
      for (var a = 0; a < axes.length; a++) {
        if (v.opts[axes[a]] !== sel[axes[a]]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // ── the variant rendered in the page RIGHT NOW (last server render) ─
  function currentRenderedVariantId() {
    var s = document.querySelector('variant-picker[context="main_product"] script[data-variant], variant-picker:not([context]) script[data-variant]');
    if (s) { try { return String((JSON.parse(s.textContent) || {}).id || ''); } catch (e) { /* ignore */ } }
    var idInput = getIdInput();
    return idInput ? String(idInput.value || '') : '';
  }

  // ── modal preview image ────────────────────────────────────────────
  function setPreviewImage(src) {
    var wrap = document.querySelector('.cg-drawer-preview');
    if (!wrap) return;
    var img = wrap.querySelector('.cg-drawer-preview-img');
    if (!img) return;
    if (src) { if (img.getAttribute('src') !== src) img.setAttribute('src', src); wrap.hidden = false; }
    else { wrap.hidden = true; }
  }

  // ── modal price (server-rendered money string from the variant map) ─
  function setModalPrice(priceStr) {
    document.querySelectorAll('.cg-drawer-price').forEach(function (el) {
      if (priceStr) { el.textContent = priceStr; el.hidden = false; }
      else { el.hidden = true; }
    });
  }

  // ── PDP price near the title (T-505 Phase D) — tracks the modal selection
  //    so the visible price isn't stuck on the base "from" price. ─────────
  function setPagePrice(priceStr) {
    if (!priceStr) return;
    document.querySelectorAll('.cg-native-price').forEach(function (el) { el.textContent = priceStr; });
  }

  // ── in-drawer Add button availability ──────────────────────────────
  function setAddAvailability(available) {
    document.querySelectorAll('.cg-drawer-add').forEach(function (btn) {
      if (available) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        if (btn.dataset.cgLabel) { btn.textContent = btn.dataset.cgLabel; delete btn.dataset.cgLabel; }
      } else {
        if (!btn.dataset.cgLabel) btn.dataset.cgLabel = btn.textContent;
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = 'Sold out';
      }
    });
  }

  // ── apply the current selection (pure JS — NO section rerender) ─────
  function applySelection() {
    var sel = getSelectedOptions();
    var v = findVariant(sel);
    var idInput = getIdInput();
    if (v) {
      if (idInput) idInput.value = v.id;        // cart submits THIS variant
      setModalPrice(v.price);
      setPagePrice(v.price);                     // PDP price tracks the selection
      setPreviewImage(v.img);
      setAddAvailability(v.available !== false);
    } else {
      setAddAvailability(false);                // incomplete / impossible combo
    }
    updateComboTrigger();
    updateSelectedNames();
  }

  // ── show the chosen Colour/Hardware name next to the group heading ──
  // (dot swatches don't carry a visible name; this is where the customer reads
  // their selection, e.g. "COLOUR: Jet Black" / "HARDWARE: Gold (Solid Brass)")
  function updateSelectedNames() {
    document.querySelectorAll('.cg-selector-selected[data-cg-selected-axis]').forEach(function (el) {
      var axis = el.dataset.cgSelectedAxis;
      var group = document.querySelector('.cg-vmirror-group[data-cg-vmirror-axis="' + CSS.escape(axis) + '"]');
      var active = group && group.querySelector('.cg-vmirror-btn--active');
      var label = active ? (active.dataset.cgLabel || active.dataset.cgVmirrorVal || '') : '';
      el.textContent = label ? ': ' + label : '';
    });
  }

  // ── line-item property helpers (Personalisation, free-text Size) ───
  function injectProperty(propName, value) {
    var f = getForm();
    if (!f) return;
    var safeId = 'cg-prop-' + propName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
    var input = f.querySelector('#' + CSS.escape(safeId));
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.id = safeId; input.name = 'properties[' + propName + ']';
      f.appendChild(input);
    }
    input.value = value;
  }
  function removeProperty(propName) {
    var f = getForm();
    if (!f) return;
    var safeId = 'cg-prop-' + propName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
    var input = f.querySelector('#' + CSS.escape(safeId));
    if (input) input.remove();
  }

  // ── hide ALL native variant fieldsets — the modal vmirror is the sole UI ─
  function hideAllVariantFieldsets() {
    document.querySelectorAll('variant-picker .variant-picker__option').forEach(function (fs) {
      if (fs.style.display !== 'none') { fs.style.display = 'none'; fs.setAttribute('aria-hidden', 'true'); }
    });
  }

  // ── re-sync each vmirror group's active button from the checked native radio ─
  // Used after a close-sync rerender + on a ?variant= deep link. During tapping
  // the vmirror IS the source of truth, so this only runs post-rerender / at init.
  function syncVmirrorFromNative() {
    document.querySelectorAll('.cg-vmirror-group').forEach(function (group) {
      var axis = (group.dataset.cgVmirrorAxis || '').replace(/:/g, '').toLowerCase().trim();
      var fieldsets = document.querySelectorAll('variant-picker[context="main_product"] .variant-picker__option, variant-picker:not([context]) .variant-picker__option');
      var val = null;
      for (var f = 0; f < fieldsets.length; f++) {
        var legend = fieldsets[f].querySelector('legend');
        var lt = legend ? (legend.textContent || '').replace(/:/g, '').toLowerCase().trim() : '';
        if (lt !== axis) continue;
        var checked = fieldsets[f].querySelector('input[type="radio"]:checked');
        if (checked) {
          var lab = fieldsets[f].querySelector('label[for="' + CSS.escape(checked.id) + '"]');
          if (lab) { var sr = lab.querySelector('.sr-only'); val = (sr ? sr.textContent : lab.textContent || '').trim(); }
        }
        break;
      }
      if (!val) return;
      group.querySelectorAll('.cg-vmirror-btn').forEach(function (b) {
        var on = (b.dataset.cgVmirrorVal === val);
        b.classList.toggle('cg-vmirror-btn--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  // ── set the hidden native radio for one axis WITHOUT firing change ──
  // Returns true if the checked radio actually changed.
  function setNativeRadioSilently(axisName, val) {
    if (!axisName || !val) return false;
    var lcAxis = String(axisName).replace(/:/g, '').toLowerCase().trim();
    var lcVal = String(val).toLowerCase().trim();
    var pickers = document.querySelectorAll('variant-picker[context="main_product"], variant-picker:not([context])');
    if (!pickers.length) pickers = document.querySelectorAll('variant-picker');
    for (var p = 0; p < pickers.length; p++) {
      var fieldsets = pickers[p].querySelectorAll('.variant-picker__option');
      for (var f = 0; f < fieldsets.length; f++) {
        var legend = fieldsets[f].querySelector('legend');
        var lt = legend ? (legend.textContent || '').replace(/:/g, '').toLowerCase().trim() : '';
        if (lt !== lcAxis) continue;
        var labels = fieldsets[f].querySelectorAll('label');
        for (var i = 0; i < labels.length; i++) {
          var sr = labels[i].querySelector('.sr-only');
          var ltxt = (sr ? sr.textContent : labels[i].textContent || '').toLowerCase().trim();
          if (ltxt === lcVal) {
            var inputId = labels[i].getAttribute('for');
            var input = inputId && document.getElementById(inputId);
            if (input) { var was = input.checked; if (!was) input.checked = true; return !was; }
          }
        }
      }
    }
    return false;
  }

  // ── sync the PDP to the chosen combo via ONE Prestige variant change ─
  // Called only on modal close. Sets every axis radio silently, then dispatches
  // a single `change` on a name*=option radio → theme.js onOptionChanged reads
  // all checked radios → one selectCombination → one section rerender (gallery /
  // URL / sticky bar). Invisible: the modal is already closed.
  function commitToPrestige() {
    if (cgSkipCommit) { cgSkipCommit = false; return; }
    var sel = getSelectedOptions();
    var v = findVariant(sel);
    if (!v) return;
    if (String(v.id) === currentRenderedVariantId()) return; // nothing changed
    var lastChanged = null, anyChanged = false;
    Object.keys(sel).forEach(function (axis) {
      var changed = setNativeRadioSilently(axis, sel[axis]);
      if (changed) { anyChanged = true; }
    });
    if (!anyChanged) return;
    // Dispatch change on any one option radio — Prestige recomputes from ALL checked.
    var anyOption = document.querySelector('variant-picker[context="main_product"] input[data-option-position], variant-picker:not([context]) input[data-option-position]');
    if (anyOption) anyOption.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ── trigger pill: label names the chosen Colour/Hardware/Size; dots paint ─
  var DOT_COLOURS = {
    'Jet Black': '#1a1a1a', 'British Burgundy': '#6b1c2e', 'Cavendish Red': '#b83232',
    'Whisky Tan': '#c47c3a', 'Midnight Blue': '#1c2e50', 'Sacramento Green': '#2a4a28',
    'Polar': '#f0ede6',
    'Brass': '#b8973e', 'Silver': '#9ba5b0'
  };
  function updateComboTrigger() {
    var trigger = document.querySelector('.cg-combo-trigger');
    if (!trigger) return;
    var labelEl = trigger.querySelector('.cg-combo-trigger-label');
    var defaultLabel = trigger.dataset.defaultLabel || '';
    var vals = [], dotVals = [], seen = {};
    document.querySelectorAll('.cg-vmirror-group').forEach(function (g) {
      var axis = g.dataset.cgVmirrorAxis || '';
      if (seen[axis]) return; seen[axis] = true;
      var active = g.querySelector('.cg-vmirror-btn--active');
      if (active) {
        vals.push(active.dataset.cgVmirrorVal || '');
        if (g.classList.contains('cg-vmirror-group--swatch')) dotVals.push(active.dataset.cgVmirrorVal || '');
      }
    });
    if (labelEl) labelEl.textContent = vals.filter(Boolean).length ? vals.filter(Boolean).join(' · ') : defaultLabel;
    var dots = trigger.querySelectorAll('.cg-combo-trigger-dot');
    dots.forEach(function (dot, i) {
      var v = dotVals[i];
      var hex = v && DOT_COLOURS[v];
      if (hex) { dot.style.background = hex; dot.classList.add('cg-combo-trigger-dot--selected'); }
      else { dot.style.removeProperty('background'); dot.classList.remove('cg-combo-trigger-dot--selected'); }
    });
  }

  // ── personalisation char-limit feedback (explain the 8-char cap) ───
  // T-1086: `sticky` = shown because Done / Add to basket was BLOCKED. It stays until the customer fixes the
  // name (the input handler clears it); the 2.6s auto-hide is only for the transient typing-past-the-cap nudge.
  function showLimitError(inp, sticky) {
    var prop = inp.dataset.cgProperty;
    var groups = [inp.closest('.cg-selector-group')];
    if (sticky && prop) { // the drawer copy and the inline copy are separate nodes; the customer may be looking at either
      document.querySelectorAll('.cg-text-input[data-cg-property="' + CSS.escape(prop) + '"]').forEach(function (o) { groups.push(o.closest('.cg-selector-group')); });
    }
    groups.forEach(function (grp) {
      var err = grp && grp.querySelector('.cg-text-limit-error');
      if (!err) return;
      err.hidden = false;
      clearTimeout(err._cgTimer);
      if (sticky) err.dataset.cgSticky = '1';
      else if (err.dataset.cgSticky !== '1') err._cgTimer = setTimeout(function () { err.hidden = true; }, 2600);
    });
  }
  // #105: the Personalisation input deliberately has NO native maxlength (it carries data-cg-max). On Android
  // (Gboard / Samsung keyboard) Chrome clips IME text to maxlength during composition BEFORE any JS runs, so the
  // customer sees a quietly shortened name and no message (reproduced with a real CDP IME session, 2026-10-18). With
  // no native clip the whole name lands, we count it, show the limit and block Done / Add to basket until it is fixed.
  // Other inputs (free-text Size, maxlength 40) keep their native maxlength.
  function capOf(inp) { return parseInt(inp.getAttribute('data-cg-max') || inp.getAttribute('maxlength'), 10) || 0; }
  // T-1086: the Personalisation cap is enforced where the customer COMMITS, not per keystroke: an Android IME
  // (Gboard, Samsung), autocorrect, predictive text or a paste can put more than maxlength into the field without
  // a usable keydown (Martin's Samsung check 2026-10-06). Reads the live input value, so it holds whatever path
  // the text took. Returns the first over-cap input (or null).
  function persoOverCap() {
    var bad = null;
    document.querySelectorAll('.cg-text-input[data-cg-property]').forEach(function (inp) {
      var cap = capOf(inp);
      if (!bad && cap && (inp.value || '').length > cap) bad = inp;
    });
    return bad;
  }
  // Block + explain: the message stays up and focus goes to the visible field. Used by Done and by validate() (Add to basket).
  function blockOverCap(inp) {
    showLimitError(inp, true);
    var vis = null;
    document.querySelectorAll('.cg-text-input[data-cg-property="' + CSS.escape(inp.dataset.cgProperty) + '"]').forEach(function (o) {
      if (!vis && o.offsetParent !== null) vis = o;
    });
    if (vis) { try { vis.focus({ preventScroll: true }); } catch (_) {} }
    return vis || inp;
  }

  // ── re-inject PROPERTY state + repopulate text fields after a rerender ─
  function restoreSelections() {
    Object.keys(cgState).forEach(function (key) {
      var val = cgState[key];
      if (val != null && String(val).length > 0) {
        // T-1086: the form property never exceeds the input's cap (the field itself keeps what was typed so the customer can fix it)
        var capInp = document.querySelector('.cg-text-input[data-cg-property="' + CSS.escape(key) + '"]');
        var capN = capInp ? capOf(capInp) : 0;
        var sv = String(val);
        injectProperty(key, capN && sv.length > capN ? sv.slice(0, capN) : val);
      }
    });
    document.querySelectorAll('.cg-text-input[data-cg-property]').forEach(function (inp) {
      var prop = inp.dataset.cgProperty;
      if (cgState[prop] != null) inp.value = cgState[prop];
    });
  }

  // ── validate required fields (only free-text Size is required) ─────
  function validate() {
    restoreSelections();
    var valid = true, firstBad = null;
    // T-1086: an over-cap Personalisation blocks Add to basket (every add path funnels through validate()).
    var overCap = persoOverCap();
    var capBad = overCap ? blockOverCap(overCap) : null;
    document.querySelectorAll('.cg-text-input[data-cg-required="true"]').forEach(function (inp) {
      var v = (inp.value || '').trim();
      var errEl = inp.closest('.cg-selector-group') && inp.closest('.cg-selector-group').querySelector('.cg-selector-error');
      if (!v) {
        valid = false; inp.classList.add('cg-text-input--error');
        if (errEl) errEl.classList.add('cg-selector-error--visible');
        if (!firstBad) firstBad = errEl || inp;
      } else {
        inp.classList.remove('cg-text-input--error');
        if (errEl) errEl.classList.remove('cg-selector-error--visible');
      }
    });
    var wrap = document.querySelector('.cg-combo-trigger-wrap');
    var pillVisible = wrap && getComputedStyle(wrap).display !== 'none';
    var pillErr = document.querySelector('.cg-combo-trigger-error');
    if (!valid && pillVisible) {
      var btn = wrap.querySelector('.cg-combo-trigger');
      if (btn) btn.classList.add('cg-combo-trigger--error');
      if (pillErr) pillErr.hidden = false;
      firstBad = wrap;
    } else {
      var btn2 = wrap && wrap.querySelector('.cg-combo-trigger');
      if (btn2) btn2.classList.remove('cg-combo-trigger--error');
      if (pillErr) pillErr.hidden = true;
    }
    if (!valid && firstBad) firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else if (capBad) { (capBad.closest('.cg-selector-group') || capBad).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return valid && !overCap;
  }

  // ── vmirror button click — INSTANT, JS-only, NO section rerender ────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cg-vmirror-btn');
    if (!btn || btn.disabled) return;
    var group = btn.closest('.cg-vmirror-group');
    if (!group) return;
    var axis = group.dataset.cgVmirrorAxis || '';
    var val = btn.dataset.cgVmirrorVal || '';
    // mirror active state across dialog + inline copies
    document.querySelectorAll('.cg-vmirror-group[data-cg-vmirror-axis="' + CSS.escape(axis) + '"] .cg-vmirror-btn').forEach(function (b) {
      b.classList.remove('cg-vmirror-btn--active'); b.setAttribute('aria-pressed', 'false');
    });
    document.querySelectorAll('.cg-vmirror-group[data-cg-vmirror-axis="' + CSS.escape(axis) + '"] .cg-vmirror-btn[data-cg-vmirror-val="' + CSS.escape(val) + '"]').forEach(function (b) {
      b.classList.add('cg-vmirror-btn--active'); b.setAttribute('aria-pressed', 'true');
    });
    applySelection(); // hidden id + modal price + preview + add-avail + trigger
    var pillErr = document.querySelector('.cg-combo-trigger-error');
    if (pillErr) pillErr.hidden = true;
    var t = document.querySelector('.cg-combo-trigger'); if (t) t.classList.remove('cg-combo-trigger--error');
  });

  // ── text inputs (Personalisation + free-text Size) ─────────────────
  // T-1086: also bound to `change` and `compositionend` (below) so autocorrect / IME commits that fire no usable
  // `input` event still sync the basket property, the counter and the trim.
  function onTextInput(e) {
    var inp = e.target.closest('.cg-text-input[data-cg-property]');
    if (!inp) return;
    var prop = inp.dataset.cgProperty;
    var val = inp.value || '';
    // #105: NEVER trim silently. Over the cap (mid-composition or committed) = the limit message goes up now and stays
    // until the name is back within the cap; Done and Add to basket are blocked by validate() / the Done handler.
    var cap = capOf(inp);
    if (cap && val.length > cap) showLimitError(inp, true);
    cgState[prop] = val;
    document.querySelectorAll('.cg-text-input[data-cg-property="' + CSS.escape(prop) + '"]').forEach(function (o) { if (o !== inp) o.value = val; });
    // defence in depth: the hidden basket property never holds more than the cap, even while an IME is mid-composition
    if (val.length > 0) injectProperty(prop, cap && val.length > cap ? val.slice(0, cap) : val); else removeProperty(prop);
    var counter = inp.parentNode && inp.parentNode.querySelector('.cg-char-count');
    if (counter) {
      var remaining = (capOf(inp) || 8) - val.length;
      counter.textContent = remaining >= 0
        ? remaining + ' character' + (remaining === 1 ? '' : 's') + ' remaining'
        : (-remaining) + ' character' + (remaining === -1 ? '' : 's') + ' too many';
      counter.classList.toggle('cg-char-count--warn', remaining <= 2);
    }
    // the blocked-Done/Add message clears as soon as the name is back within the cap
    document.querySelectorAll('.cg-text-input[data-cg-property="' + CSS.escape(prop) + '"]').forEach(function (o) {
      var g = o.closest('.cg-selector-group');
      var limErr = g && g.querySelector('.cg-text-limit-error');
      if (!limErr) return;
      var c = capOf(o) || 99;
      if (limErr.dataset.cgSticky === '1') { if (val.length <= c) { limErr.hidden = true; delete limErr.dataset.cgSticky; } }
      else if (val.length < c) limErr.hidden = true;
    });
    if (inp.dataset.cgRequired === 'true' && val.trim().length > 0) {
      inp.classList.remove('cg-text-input--error');
      var errEl = inp.closest('.cg-selector-group') && inp.closest('.cg-selector-group').querySelector('.cg-selector-error');
      if (errEl) errEl.classList.remove('cg-selector-error--visible');
    }
  }
  document.addEventListener('input', onTextInput);
  document.addEventListener('change', onTextInput);
  // once an IME commits, re-run the handler (now not composing) so trim, message, counter and property settle on the committed text
  document.addEventListener('compositionend', function (e) {
    var inp = e.target.closest && e.target.closest('.cg-text-input[data-cg-property]');
    if (!inp) return;
    onTextInput({ target: inp, isComposing: false });
  });

  // ── block + explain when typing past the maxlength (Personalisation 8) ─
  document.addEventListener('keydown', function (e) {
    var inp = e.target.closest && e.target.closest('.cg-text-input[maxlength]');
    if (!inp) return;
    var max = parseInt(inp.getAttribute('maxlength'), 10);
    if (!max) return;
    if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
      var hasSelection = inp.selectionStart !== inp.selectionEnd;
      if (!hasSelection && (inp.value || '').length >= max) {
        e.preventDefault();
        showLimitError(inp);
      }
    }
  });
  document.addEventListener('paste', function (e) {
    var inp = e.target.closest && e.target.closest('.cg-text-input[maxlength]');
    if (!inp) return;
    var max = parseInt(inp.getAttribute('maxlength'), 10);
    if (!max) return;
    var txt = ((e.clipboardData || window.clipboardData) && (e.clipboardData || window.clipboardData).getData('text')) || '';
    var selLen = inp.selectionEnd - inp.selectionStart;
    if ((inp.value || '').length - selLen + txt.length > max) showLimitError(inp);
  });

  // ============================================================
  // T-758 (2026-08-05) — WHATEVER SIZE THE DRAWER OPENS AT, IT KEEPS.
  // Twin of `lockDrawerHeight` in cats-atelier-pdp.js — keep the two in step.
  //
  // Martin: "we just need to ensure that whatever the size of the modal upon opening that never
  // changes when variants are selected." This drawer was the worse of the two: measured on live
  // it was 780.4px at EVERY viewport height (i.e. content-sized, ignoring the viewport), and its
  // top drifted 110.6 -> 169.6 -> 219.6 as a result. Under `max-height:88vh` the box tracks its
  // content, so a colour that swaps the preview image or shows an OOS tag resizes AND — being
  // bottom-anchored — moves it.
  // NOT solved with a blanket `height:88vh`: that forces every modal to full height and leaves
  // low-option products with a mostly-empty sheet. Freeze the opened height instead; the body
  // already scrolls, so later content growth stays reachable.
  // MOBILE ONLY (<=749px) — the defect is mobile and desktop is a centred card where
  // content-sizing is correct. Re-measured on resize/rotate; cleared on close so the next open
  // measures afresh.
  // ============================================================
  // ============================================================
  // T-760 (2026-08-05) — LOCK THE PAGE WHILE THE SHEET IS OPEN.
  // Twin of the block in cats-atelier-pdp.js — keep the two in step.
  //
  // Martin reported two symptoms; they are ONE bug. Measured on Test at 412x891 with the sheet
  // open, the page scrolled 738 -> 1138 behind it (`html`/`body` overflow both `visible`;
  // `showModal()` does not lock page scroll). The "header scrolls out of view and the buttons
  // move up" symptom is the same cause seen on a real phone: a page scroll animates the browser
  // toolbar, the visual viewport shifts, and this bottom-anchored fixed sheet slides with it.
  // `position:fixed` on <body>, not `overflow:hidden` on <html>, because iOS Safari ignores the
  // latter. MOBILE ONLY (<=749px): on desktop, removing the page scrollbar shifts layout by ~15px
  // — the T-756 nudge — and the bug is mobile.
  // ============================================================
  var cgScrollLockY = 0;
  function lockBackgroundScroll() {
    if (window.innerWidth > 749) return;
    if (document.body.dataset.cgScrollLocked === '1') return;
    cgScrollLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-cgScrollLockY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
    b.dataset.cgScrollLocked = '1';
  }
  function unlockBackgroundScroll() {
    var b = document.body;
    if (b.dataset.cgScrollLocked !== '1') return;
    b.style.position = ''; b.style.top = ''; b.style.left = '';
    b.style.right = ''; b.style.width = ''; b.style.overflow = '';
    delete b.dataset.cgScrollLocked;
    window.scrollTo(0, cgScrollLockY);
  }
  // Bound to the dialog's `close` event so every exit is covered by one path — Done, the X, the
  // backdrop, in-drawer Add, and ESC (which no click handler can see).
  function bindScrollUnlock(dlg) {
    if (!dlg || dlg._cgScrollBound) return;
    dlg.addEventListener('close', unlockBackgroundScroll);
    dlg._cgScrollBound = true;
  }

  function lockDrawerHeight(dlg) {
    if (!dlg || !dlg.open) return;
    if (window.innerWidth > 749) { dlg.style.height = ''; return; }
    dlg.style.height = '';               // measure the natural size, not a stale lock
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!dlg.open) return;
        var h = dlg.getBoundingClientRect().height;
        if (h > 0) dlg.style.height = Math.round(h) + 'px';
      });
    });
  }
  function unlockDrawerHeight(dlg) { if (dlg) dlg.style.height = ''; }
  window.addEventListener('resize', function () {
    var open = document.querySelector('dialog.cg-combo-drawer[open]');
    if (open) lockDrawerHeight(open);
  });

  // ── drawer open / close (delegated) ────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cg-combo-trigger')) {
      var dlg = document.querySelector('dialog.cg-combo-drawer');
      if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
        // T-826 (2026-10-07): pill state BEFORE opening - .cg-combo-trigger--error is set only by a
        // failed validate() (an Add to Basket with a required choice missing). Twin of the CA drawer.
        var cgOpenTrigger = e.target.closest('.cg-combo-trigger').classList.contains('cg-combo-trigger--error') ? 'pill_error' : 'pill';
        // bind the close→sync handler once per dialog node (re-bound on a fresh
        // node after each close-sync rerender)
        if (!dlg._cgCloseBound) { dlg.addEventListener('close', commitToPrestige); dlg._cgCloseBound = true; }
        dlg.showModal();
        // T-826: same event/shape as the CA drawer (cats-atelier-pdp.js) -- rebuilds the
        // option-modal-open telemetry lost when T-516 replaced Infinity Options. C&G's own
        // Add to Basket is native (not drawer-gated the way CA's is), so this event completes
        // the open-rate half of the funnel for this vendor too, on the same axis. Guarded like
        // the existing miacara_import_info_click pattern (cart-shipping-message.liquid).
        if (typeof gtag === 'function') {
          gtag('event', 'select_options_open', {
            item_id: cgPid,
            product_handle: ((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || ''),
            vendor: 'Cub & Grey',
            device: window.innerWidth <= 749 ? 'mobile' : 'desktop',
            open_trigger: cgOpenTrigger
          });
        }
        applySelection(); // refresh price/preview to the current selection
        // T-760: lock the page FIRST — <body> going position:fixed changes layout, so T-758's
        // height measurement must run after it.
        lockBackgroundScroll();
        bindScrollUnlock(dlg);
        lockDrawerHeight(dlg);  // T-758 — after applySelection, so we freeze what the customer sees
      }
      return;
    }
    if (e.target.classList && e.target.classList.contains('cg-combo-drawer')) {
      if (e.target.open) { unlockDrawerHeight(e.target); e.target.close(); } // backdrop click
      return;
    }
    if (e.target.closest('.cg-drawer-close')) {
      var open = document.querySelector('dialog.cg-combo-drawer[open]');
      if (open) { unlockDrawerHeight(open); open.close(); }
    }
  });

  // ── in-drawer Add to Basket — submit immediately, no close-sync race ─
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cg-drawer-add')) return;
    if (!validate()) return;          // errors shown in-drawer; keep open
    applySelection();                 // ensure the hidden id is current
    cgSkipCommit = true;              // this close must NOT trigger a Prestige fetch
    var dlg = document.querySelector('dialog.cg-combo-drawer[open]');
    if (dlg) { unlockDrawerHeight(dlg); dlg.close(); }   // T-758: clear so the next open re-measures
    var atc = document.querySelector(
      'buy-buttons button[type="submit"], product-form button[type="submit"]:not(quick-buy button), ' +
      '.product-info__block-item[data-block-type="buy-buttons"] button[type="submit"], ' +
      'form[action*="/cart/add"] button[type="submit"]:not([form*="quick"])'
    );
    if (atc) atc.click();
  });

  // ── T-1086: Done is a commit point too. An over-cap name keeps the sheet open with the message up.
  //    Capture phase, so it runs before the delegated close handler above. ─
  window.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.cg-drawer-done')) return;
    restoreSelections();
    var bad = persoOverCap();
    if (!bad) return;
    e.preventDefault(); e.stopImmediatePropagation();
    blockOverCap(bad);
  }, true);

  // ── capture ATC / submit: block if required free-text size missing ─
  window.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="add"], buy-buttons button[type="submit"], product-form button[type="submit"]');
    if (!btn) return;
    if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  window.addEventListener('submit', function (e) {
    if (!e.target.closest('form[action*="cart/add"]')) return;
    if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // ── after a close-sync rerender: re-hide fieldsets, re-sync vmirror,
  //    re-inject properties (the rerender wiped them), refresh modal state ─
  document.addEventListener('variant:change', function () {
    hideAllVariantFieldsets();
    syncVmirrorFromNative();
    restoreSelections();
    applySelection();
  });

  // ── init ───────────────────────────────────────────────────────────
  function init() {
    var f = getForm();
    if (!f) { requestAnimationFrame(init); return; }
    hideAllVariantFieldsets();
    syncVmirrorFromNative();          // honour ?variant= deep links
    // seed any pre-filled property text inputs into state
    document.querySelectorAll('.cg-text-input[data-cg-property]').forEach(function (inp) {
      if (inp.value) { cgState[inp.dataset.cgProperty] = inp.value; injectProperty(inp.dataset.cgProperty, inp.value); }
    });
    applySelection();                 // hidden id + modal price + preview + trigger
  }
  init();
})();
